/**
 *
 * MediaPlayback Component
 *
 * Wrapper component to simplify server-side rendering. This component requires a `__CLIENT__` variable
 * to be defined in the webpack build.
 * - `__CLIENT__ === true`: Client-side rendering
 * - `__CLIENT__ === false`: Server-side rendering
 *
 */
import { FC } from 'react';
import { MediaPlaybackProps } from './mediaPlayback.types';

// Check whether __CLIENT__ is defined
const isClient = (typeof __CLIENT__ !== 'undefined') ? __CLIENT__ : true;

const MediaPlaybackWrapper: FC<MediaPlaybackProps> = (isClient)
  ? require('./mediaPlayback').default //eslint-disable-line @typescript-eslint/no-require-imports
  : require('./mediaPlaybackContainer').default; //eslint-disable-line @typescript-eslint/no-require-imports
;

export default MediaPlaybackWrapper;
